
import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    result: any = {};
    code = '';
    text = '';

    constructor() {

    }

    public setItem(name, data) {
        try {;
            return localStorage.setItem(name, JSON.stringify(data));
        } catch (e) {
            return [];
        }
    }

    public getItem(item) {
        try {
            let data =localStorage.getItem(item);
            return (data) ? JSON.parse(data):[];
        } catch (e) {
            return [];
        }
    }
}
